module.exports = __webpack_public_path__ + "fonts/iconfont.30753f57.ttf";